module.exports = __webpack_public_path__ + "static/media/teampng2.2a122d16.png";